import React from 'react';
import CompactTableRow from '@/components/table/CompactTableRow';

const RequestSettingEnabledWarning = () => (
  <CompactTableRow
    warning
    className="aridhia-request-setting-enabled-warning"
    rowId="dataset.settings.request.enabled.warning"
    numberOfColumns={3}
  />
);

export default RequestSettingEnabledWarning;
